import { DRIVE_SYNC_AVAILABLE } from "./features";

export const TERMS_VERSION = "2026-10-14";
export const PRIVACY_VERSION = DRIVE_SYNC_AVAILABLE ? "2026-10-19" : "2026-10-15";
export const DATA_PROCESSING_VERSION = "2026-10-14";

const value = (name: string, fallback = "") => {
  const values: Record<string, string | undefined> = {
    VITE_OPERATOR_NAME: import.meta.env.VITE_OPERATOR_NAME,
    VITE_PRIVACY_CONTACT_NAME: import.meta.env.VITE_PRIVACY_CONTACT_NAME,
    VITE_PRIVACY_CONTACT_EMAIL: import.meta.env.VITE_PRIVACY_CONTACT_EMAIL,
    VITE_PRIMARY_DATA_REGION: import.meta.env.VITE_PRIMARY_DATA_REGION,
  };
  return values[name]?.trim() || fallback;
};

export const legalConfig = {
  operatorName: value("VITE_OPERATOR_NAME", "teacherlovestools"),
  contactName: value("VITE_PRIVACY_CONTACT_NAME", "資料保障聯絡主任"),
  contactEmail: value("VITE_PRIVACY_CONTACT_EMAIL", "teacherlovestools@gmail.com"),
  // Confirmed for the separate public production project on 2026-10-06.
  // A deployment using another project must set its actual primary region.
  primaryDataRegion: value("VITE_PRIMARY_DATA_REGION", "新加坡（ap-southeast-1）"),
};

export const legalConfigReady = Boolean(
  legalConfig.operatorName && legalConfig.contactName && legalConfig.contactEmail && legalConfig.primaryDataRegion,
);
